<template>
	<div class="basic-container mt-2 mb-2">
		<AgreementEntry :matchData="matchData" :apiData="apiData" v-if="stateCd === 'ENTRY'" />
		<AgreementGrow :matchData="matchData" :apiData="apiData" v-if="stateCd === 'GROW'" />
		<AgreementExpand :matchData="matchData" :apiData="apiData" v-if="stateCd !== 'ENTRY' && stateCd !== 'GROW'" />
		<div class="btn-area mt-6 mb-2">
			<button class="lineBtn big">출력</button>
			<button class="pinkBtn">제출</button>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import AgreementEntry from '@/components/mybusiness/Agreement-Entry';
import AgreementGrow from '@/components/mybusiness/Agreement-Grow';
import AgreementExpand from '@/components/mybusiness/Agreement-Expand';

export default {
	name: 'Agreement',
	props: ['matchSeqNo'],
	components: { AgreementEntry: AgreementEntry, AgreementGrow: AgreementGrow, AgreementExpand: AgreementExpand },
	data: function() {
		return {
			CONST,
			apiData: null,
			loginMember: null,
			matchData: null,
			select: 1,
			agreeSeqNo: 0,
			serviceCd1: '',
			serviceCd2: '',
			serviceCd3: '',
			itemNm: '',
			hsCode: 0,
			offerYn: '',
			entryFee: '',
			stateCd: '',
			stateCdEtc: '',
			mtSubmitState: 'TEMP',
			companySubmitState: 'N',
			nonAgreeReason: '',
			stateCdList: [],
			serviceCodeList: [],
			etcServiceCodeList: [],
		};
	},
	created() {},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let matchData = this.$device.loadLocalData('MATCH_DATA');
		if (matchData) this.matchData = JSON.parse(matchData);
		this.getAgreement();
	},
	methods: {
		getAgreement: function() {
			let formData = new FormData();
			formData.append('matchSeqNo', this.matchSeqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getAgreement.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						if (res.data.data !== null) {
							this.apiData = res.data.data;
							this.agreeSeqNo = this.apiData.agreeSeqNo;
							this.nonAgreeReason = this.apiData.nonAgreeReason;
							this.hsCode = this.apiData.hsCode;
							this.itemNm = this.apiData.itemNm;
							this.offerYn = this.apiData.offerYn;
							this.entryFee = this.apiData.entryFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

							let serviceCd = this.apiData.serviceCd.split('|');
							this.serviceCd1 = serviceCd[0];
							this.serviceCd2 = serviceCd[1];
							this.serviceCd3 = serviceCd[2];
							if (this.stateCd !== 'ENTRY' && this.stateCd !== 'GROW') {
								let stateCdEtc = this.apiData.stateCd.split('|');
								if (stateCdEtc) this.stateCdEtc = stateCdEtc[1];
								this.serviceCd3 = serviceCd[1];
							}
							this.getEtcServiceCodeList();
						}
						this.getServiceCodeList();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getStateCdList: function() {
			this.stateCdList = [];
			let formData = new FormData();
			formData.append('parentCodeCd', 'LOCAL_COMPANY_STATE');
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getMngCodeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.stateCdList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getServiceCodeList: function() {
			this.serviceCodeList = [];
			if (this.stateCd === '') {
				return false;
			}
			let formData = new FormData();
			formData.append('stateCd', this.stateCd);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getServiceCodeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.serviceCodeList = res.data.data;
						//this.$set(this.serviceCdRowData, idx, nInfo);
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getEtcServiceCodeList: function() {
			this.etcServiceCodeList = [];
			if (this.stateCdEtc === '') {
				return false;
			}
			let formData = new FormData();
			formData.append('stateCd', this.stateCdEtc);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getServiceCodeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.etcServiceCodeList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped></style>
